import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBimM8E6UWf8jMCMNwEE-zpmp4WiJJpinU",
  authDomain: "pacioworkflow.firebaseapp.com",
  projectId: "pacioworkflow",
  storageBucket: "pacioworkflow.firebasestorage.app",
  messagingSenderId: "736699049469",
  appId: "1:736699049469:web:3789a8ecee71f587172594"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
